/* eslint-disable comma-dangle */
import React, { useEffect, useState } from 'react'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import { useSelector } from 'react-redux'
import { Grid } from '@material-ui/core/'
import { useHistory, useParams } from 'react-router-dom'
import { Menu } from 'components'
import { MediaCard, LinearDeterminate } from 'components/UI/'
import { useDebouncedCallback } from 'use-debounce'
import api from '../../api/stoty'
import './index.scss'

const ReactionStory = () => {
  const [myLastStorys, setMylastStorys] = useState([])
  const [userOnlineSotirys, setUSerOnlineStorys] = useState([])
  const [loading, setLoading] = useState(false)
  const [visibleStorys, setVisibleStorys] = useState(false)
  const history = useHistory()
  const { user } = useSelector(({ session }) => session)
  const { audioState } = useSelector(({ audio }) => audio)
  const { reaction, reactionId, idPodcast } = useParams()

  const ucFirst = () => {
    if (!reaction) return reaction

    return reaction?.[0]?.toUpperCase() + reaction.slice(1)
  }

  useEffect(() => {
    if (Math?.round(audioState?.time) === 3) {
      debouncedListen()
    }
  }, [audioState?.time])

  const goTo = storyId => history.push(`/story/${storyId?.uuid}`)

  const getReactionStories = feedback => {
    api.getReactionStories(idPodcast, user?.accessKey, reactionId)
      .then(res => setMylastStorys(res?.data?.stories || []))
      .catch(error => console.error(error))
  }

  useEffect(() => {
    getReactionStories()
  }, [])

  const listenPodcast = id => {
    if (user?.accessKey) {
      api?.listenPodcastLogin(id, user?.accessKey)
        .catch(error => console.error(error))
    } else {
      api?.listenPodcastNoLogin(id)
        .catch(error => console.error(error))
    }
  }

  const debouncedListen = useDebouncedCallback(
    () => {
      listenPodcast(audioState?.podcast?.podcast?.uuid)
    }, 500
  )

  useEffect(() => {
    if (myLastStorys?.length || userOnlineSotirys?.length) {
      setVisibleStorys(true)
    }
  }, [myLastStorys, userOnlineSotirys])

  return (
    <Grid className='wrapperHomePageReaction'>
      <div className='wrapperMenuMobile'>
        <Menu />
      </div>

      {loading && <LinearDeterminate visible />}

      <div className='wrapperStoriesReactions'>
        <div className='reactionStoryTitle'>
          All stories from those who answered “{ucFirst()}”:
        </div>

        {visibleStorys && (
          <ResponsiveMasonry columnsCountBreakPoints={{ 319: 1, 767: 2, 1279: 3 }}>
            <Masonry columnsCount={3} gutter={30}>
              {myLastStorys?.map(i => (
                <div key={i?.uuid} className='itemHoverEffect'>
                  <MediaCard goTo={goTo} data={i} />
                </div>
              ))}
            </Masonry>
          </ResponsiveMasonry>
        )}
      </div>
    </Grid>
  )
}

export default ReactionStory
